import { AlertCircle } from "lucide-react";
import { cn } from "@punchup/utils/cn";

// Aye Approved error design
// From https://www.figma.com/design/gqfCbyIOOKFYdWEuuKAd5k/Design-System?node-id=2251-11264&t=CnguQjC3uutAvoMt-0
export default function ErrorMessage({
  domId,
  error,
  className,
  title,
}: {
  domId?: string;
  error: string | React.ReactNode;
  className?: string;
  title?: string;
}) {
  return (
    <div
      id={domId}
      className={cn(
        "bg-red-50 w-full text-red-500 text-sm px-4 py-2 rounded-md flex items-center gap-2 border border-red-500",
        className
      )}
    >
      <AlertCircle className="w-6 h-6" />{" "}
      <div className="flex flex-col gap-y-1">
        {title && <div className="text-sm font-semibold">{title}</div>}
        <div>{error}</div>
      </div>
    </div>
  );
}
